import { Component, OnInit } from '@angular/core'
import { FieldWrapper, FormlyFieldConfig } from '@ngx-formly/core'
import { SvgIconComponent } from 'angular-svg-icon'

import { ButtonComponent } from '../../../button/button.component'
import { FormlyFieldProps } from '../../types/common.types'

interface FormlyGroupProps extends FormlyFieldProps {
  add?(): void
  remove?(): void
}

export type GroupFieldConfig = FormlyFieldConfig<FormlyGroupProps>

@Component({
  selector: 'app-group-field-wrapper',
  standalone: true,
  imports: [SvgIconComponent, ButtonComponent],
  templateUrl: './group-field-wrapper.component.html',
})
export class GroupFieldWrapperComponent
  extends FieldWrapper<GroupFieldConfig>
  implements OnInit
{
  public keyAsNumber: number = 0

  public ngOnInit(): void {
    this.keyAsNumber = Number.parseInt(this.key as string)
    this.formControl.valueChanges.subscribe(
      () => (this.keyAsNumber = Number.parseInt(this.key as string))
    )
  }
}
